import { getAuth, createUserWithEmailAndPassword, sendEmailVerification, signOut, signInWithPhoneNumber, RecaptchaVerifier, deleteUser, signInWithEmailAndPassword } from "firebase/auth";
import { CreateAccountApi, VerifyAccountApi, checkEmailVerification } from "apis/authServices";
import { NavigateFunction } from "react-router-dom";
import { useToastStore } from "store/toastStore";
import { useGlobalLoader } from "contexts/GlobalLoaderContext";
import { useStore } from "store/zustand";




export const handleSendCode = async (
  email: string,
  username: string,
  password: string,
  setError: (message: string) => void,
  setIsEmailVerifying: (status: boolean) => void,
  navigate: (path: string) => void,
  setIsVerified: (state: boolean) => void,
  setIsAuthenticated: (state: boolean) => void,
  referralCode?: string
) => {
  setError("");
  setIsEmailVerifying(true);
  
  
  
  const trimmedEmail = email.trim();
  const trimmedUsername = username.trim();
  const auth = getAuth();

  if (!trimmedUsername) {
    setError("Please enter your name.");
    setIsEmailVerifying(false);
    return;
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
    setError("Please enter a valid email address.");
    setIsEmailVerifying(false);
    return;
  }

  
  
  try {
      console.log("yes")
      const response = await VerifyAccountApi(trimmedEmail);
      console.log("🔍 API Response:", response);
      
      const statusId = response?.statusId ?? null;
      console.log("Status ID:",statusId)
      switch (statusId) {
        case 1: // Inactive → Redirect to Create Account
      
        try {
          // Attempt to sign in with provided password
          const userCredential = await signInWithEmailAndPassword(auth, trimmedEmail, password);
          const user = userCredential.user;
          const idToken = await user.getIdToken(); // Get Firebase ID token

          useToastStore.getState().showToast(
            "Inactive account detected. Reactivating account...",
            "info"
          );

          // Call CreateAccountApi to reactivate account
          navigate("/createAccount"); 

          
        } catch (signInError: any) {
          setError("Invalid password or account issue. Please try logging in.");
          useToastStore.getState().showToast(
            "Please verify your password or log in.",
            "error",
         
          );
        }
        return;
        case 2: // Active
        console.log("Redirecting to login...");
        useToastStore.getState().showToast(
          'Email already exists . Redirecting to Login...',
          'error'
        );
          setTimeout(() => navigate("/login"), 3000);
          return;
      
        case 3: // Blocked
        useToastStore.getState().showToast(
          response.message,
          'error'
        );
        return;
        case 4: // Deleted
        useToastStore.getState().showToast(
          response.message,
          'error'
        );
          
          return;
      
        case null: // Email does not exist (Status 200 OK)
          break;
      
        default:
          setError("Unexpected response from server.");
          return;
      }
     
      
      const userCredential = await createUserWithEmailAndPassword(auth,  trimmedEmail, password);
      console.log("User details:", userCredential.user);
      
      await sendEmailVerification(userCredential.user);
      console.log("Verification email sent!");
  
      useToastStore.getState().showToast(
        "Verification email sent! Please check your registered email ID.",
        "success"
      );
       
          const isEmailVerified = await waitForEmailVerification(userCredential.user);
          if (!isEmailVerified) {
            setError("Email verification failed. Retry.");
            await deleteUser(userCredential.user);
            return;
          }

          const createAccountResponse = await CreateAccountApi();
          console.log("CreateAccountApi Called");
          console.log("API Response:", createAccountResponse);
          if (createAccountResponse) {
            console.log(createAccountResponse)
            navigate("/createAccount");
          } else {
            setError(createAccountResponse || "Account creation failed.");
          }
        } catch (error: any) {
          if (error.code === "auth/email-already-in-use") {
            setError("This email is already in use. Redirecting to login...");
            setTimeout(() => navigate("/login"), 2000);
          } else {
            setError(error.message || "Error verifying account. Please try again.");
          }
        } finally {
          setIsEmailVerifying(false);
        }
      };

      const waitForEmailVerification = async (user: any) => {
        let attempts = 0;
        while (attempts < 20) {
          await user.reload(); // Refresh user data
          if (user.emailVerified) return true;
          await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait 5 sec
          attempts++;
        }
        return false;
      };